module.exports = __webpack_public_path__ + "img/left_tag.85c2f710.png";